import { GetOrganizations } from '../actions/orgs';

export default (store) => {
    store.dispatch(GetOrganizations());
};
